import BaseAPI from '@/apis/base/baseApi';

export default class AUDITApi extends BaseAPI {
  apiName = 'AuditVoucher';
}
